<template>
  <div id="work-experience">
    <div class="container section padding-top over-hide">
      <div class="page-title">
        <h1 class="text-center">
          my work <span class="highlight">experience</span>
        </h1>
      </div>
      <div class="row padding-top padding-bottom justify-content-center">
        <div class="col-12 mb-5">
          <div class="portfolio-filter">
            <ul class="filter">
              <li
                v-for="(field, index) in fields"
                :key="field"
                @click="changeChart(index)"
              >
                <span
                  :class="{ current: activeIndex == index }"
                  class="target"
                  >{{ field }}</span
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-md-10">
          <canvas ref="experienceChart" id="experience-chart"></canvas>
        </div>
        <div class="col-12 text-center mt-4">
          <a
            href="https://1drv.ms/b/s!AkD_a9HguUTxmLRiZrttXzc1OvO62w"
            target="_blank"
            download="Shox Adomokai's CV"
            class="h4 main-button mt-5"
            >view my cv</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/dist/Chart.js";
import ScrollReveal from "scrollreveal";
export default {
  methods: {
    getExperience(year) {
      return new Date().getFullYear() - year;
    },
    changeChart(index) {
      this.activeIndex = index;
      this.chartData.labels = this.chartfields[index].labels;
      this.chartData.datasets[0].data = this.chartfields[index].data;
      this.experienceChart.update({
        duration: 800,
        easing: "easeInOutQuint"
      });
    }
  },
  mounted() {
    this.experienceChart = new Chart(this.$refs.experienceChart, {
      type: "radar",
      data: this.chartData,
      options: this.chartOptions
    });

    ScrollReveal().reveal(".page-title", {
      duration: 1200,
      reset: true,
      distance: "100px",
      mobile: false
    });
  },
  data() {
    return {
      activeIndex: 0,
      fields: [
        "all",
        "communications design",
        "ui/ux",
        "progamming",
        "strategy"
      ],
      chartData: {
        labels: ["Communications Design", "UI/UX", "Progamming", "Strategy"],
        datasets: [
          {
            backgroundColor: "rgba(255,123,172,0.3)",
            borderColor: "#FF7BAC",
            borderWidth: 1,
            fill: true,
            radius: 5,
            pointRadius: 5,
            pointBackgroundColor: "#FF7BAC",
            pointHoverRadius: 10,
            data: [
              this.getExperience(2014),
              this.getExperience(2016),
              this.getExperience(2018),
              this.getExperience(2015)
            ]
          }
        ]
      },
      chartOptions: {
        scale: {
          ticks: {
            beginAtZero: true,
            min: 0,
            max: this.getExperience(2013),
            stepSize: 1,
            backdropColor: "transparent",
            callback: function(value) {
              return value + " yrs";
            }
          },
          gridLines: {
            color: "rgba(255,255,255,0.3)",
            circular: true
          },
          pointLabels: {
            fontSize: 12,
            fontColor: "#fff"
          },
          scaleLabel: {
            display: false
          }
        },
        legend: {
          display: false
        },
        tooltips: {
          titleMarginBottom: 15,
          footerMarginTop: 15,
          callbacks: {
            title: () => {
              return "Years of Experience";
            },
            label: (tooltipItem, data) => {
              var label = data.labels[tooltipItem.index] || "";
              return label;
            },
            afterLabel: (tooltipItem, data) => {
              return (
                tooltipItem.yLabel +
                " years working with " +
                data.labels[tooltipItem.index]
              );
            },
            footer: () => {
              if (this.activeIndex === 0) {
                return "click for detailed breakdown";
              }
            }
          }
        },
        onClick: (event, data) => {
          if (this.activeIndex === 0) {
            this.changeChart(data[0]._index + 1);
          }
        }
      },
      experienceChart: null,
      chartfields: [
        {
          labels: ["Communications Design", "UI/UX", "Progamming", "Strategy"],
          data: [
            this.getExperience(2014),
            this.getExperience(2016),
            this.getExperience(2018),
            this.getExperience(2015)
          ]
        },
        {
          labels: [
            "Photoshop",
            "Indesign",
            "Illustrator",
            "Dimensions",
            "After Effects"
          ],
          data: [
            this.getExperience(2014),
            this.getExperience(2017),
            this.getExperience(2015),
            this.getExperience(2019),
            this.getExperience(2015)
          ]
        },
        {
          labels: [
            "Adobe XD",
            "Invision Studio",
            "Interaction Design",
            "User Research",
            "Prototyping"
          ],
          data: [
            this.getExperience(2018),
            this.getExperience(2019),
            this.getExperience(2018),
            this.getExperience(2016),
            this.getExperience(2016)
          ]
        },
        {
          labels: ["HTML/CSS", "VueJS", "Node.js", "Bootstrap", "MongoDB"],
          data: [
            this.getExperience(2018),
            this.getExperience(2019),
            this.getExperience(2020),
            this.getExperience(2018),
            this.getExperience(2020)
          ]
        },
        {
          labels: [
            "Branding",
            "Email Marketing",
            "Market Research",
            "Blogging",
            "Customer Journeys"
          ],
          data: [
            this.getExperience(2015),
            this.getExperience(2017),
            this.getExperience(2016),
            this.getExperience(2018),
            this.getExperience(2019)
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.filter {
  position: relative;
  display: block;
  padding: 0;
  margin: 0;
  text-align: center;

  &::after {
    content: "";
    display: block;
    clear: both;
  }
}

.filter li {
  display: inline-block;
  margin-right: 15px;

  @media (max-width: 575px) {
    a {
      letter-spacing: 0;
      font-size: 14px;
    }
  }

  span {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    outline: none;
    color: rgba(200, 200, 200, 0.5);
    font-weight: 700;
    font-style: italic;
    letter-spacing: 1px;
    font-size: 15px;
    line-height: 22px;
    text-decoration: none;
    transition: all 300ms linear;

    &:hover {
      color: #fff;

      &::before {
        bottom: -4px;
        opacity: 1;
        visibility: visible;
      }
    }

    &:before {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: -9px;
      height: 2px;
      content: "";
      z-index: -1;
      background-color: $primary;
      opacity: 0;
      visibility: hidden;
      transition: all 200ms linear;
    }

    &.current {
      color: #fff;

      &:before {
        bottom: -4px;
        opacity: 1;
        visibility: visible;
      }
    }
  }
}

.target {
  cursor: pointer;
}
</style>
